var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items.length > 0
    ? _c(
        "div",
        { staticClass: "counterparty" },
        [
          _c("legend", [_vm._v("\n        Маршрут\n    ")]),
          _vm._v(" "),
          _c("b-table", {
            staticClass: "table-responsive-xl resolution_table",
            attrs: {
              striped: "",
              "head-variant": "dark",
              "thead-class": _vm.head_class,
              items: _vm.items,
              fields: _vm.fields,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(car)",
                  fn: function (data) {
                    return [
                      data.value.hasOwnProperty("title")
                        ? _c("div", { staticClass: "car_name" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(data.value.title) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              3424445580
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }